import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

interface OfferItem {
  type: 'offer' | 'news';
  text: string;
  bgColor?: string;
}

@Component({
  selector: 'app-offer-banner',
  imports: [CommonModule],
  templateUrl: './offer-banner.html',
  styleUrl: './offer-banner.scss'
})
export class OfferBanner implements OnInit, OnDestroy {
  private intervalId: any;
  currentIndex = 0;
  isAnimating = false;

  offers: OfferItem[] = [
    {
      type: 'offer',
      text: '🎉 Special Offer: Get 25% OFF on all Yellow Dose supplements this week!',
      bgColor: '#f59e0b'
    },
    {
      type: 'news',
      text: '📢 News: New Green Dose formula now available with enhanced absorption',
      bgColor: '#10b981'
    },
    {
      type: 'offer',
      text: '💊 Limited Time: Buy 2 Red Dose bottles and get 1 FREE!',
      bgColor: '#ef4444'
    },
    {
      type: 'news',
      text: '🔬 Latest Research: Clinical studies show 95% customer satisfaction rate',
      bgColor: '#3b82f6'
    },
    {
      type: 'offer',
      text: '🚚 Free Shipping: Orders above $50 get FREE nationwide delivery',
      bgColor: '#8b5cf6'
    },
    {
      type: 'news',
      text: '⭐ Award Winner: Named "Best Health Supplement Brand 2024"',
      bgColor: '#06b6d4'
    }
  ];

  constructor() {}

  ngOnInit(): void {
    this.startRotation();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private startRotation(): void {
    this.intervalId = setInterval(() => {
      this.nextOffer();
    }, 2000); // Change every 2 seconds
  }

  private nextOffer(): void {
    this.isAnimating = true;
    
    setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % this.offers.length;
      this.isAnimating = false;
    }, 300); // Animation duration
  }

  getCurrentOffer(): OfferItem {
    return this.offers[this.currentIndex];
  }

  getCurrentOfferStyle() {
    const offer = this.getCurrentOffer();
    const baseColor = offer.bgColor || '#3b82f6';
    
    // Create gradient variations for each color
    const gradients: Record<string, string> = {
      '#f59e0b': 'linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%)',
      '#10b981': 'linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)',
      '#ef4444': 'linear-gradient(135deg, #ef4444 0%, #dc2626 50%, #b91c1c 100%)',
      '#3b82f6': 'linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%)',
      '#8b5cf6': 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 50%, #6d28d9 100%)',
      '#06b6d4': 'linear-gradient(135deg, #06b6d4 0%, #0891b2 50%, #0e7490 100%)'
    };
    
    return {
      'background': gradients[baseColor] || `linear-gradient(135deg, ${baseColor} 0%, ${baseColor}dd 100%)`,
      'color': '#ffffff',
      'text-shadow': '0 1px 3px rgba(0, 0, 0, 0.3)'
    };
  }
}
